import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { PROFILE_GA_CATEGORY } from '../constants';
import { ActionTypes } from './constants';

export const turnBookingSpotlightOn = () => ({
    type: ActionTypes.TURN_BOOKING_SPOTLIGHT_ON,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Show Booking Section',
            category: PROFILE_GA_CATEGORY,
        },
    },
});

export const turnBookingSpotlightOff = () => ({
    type: ActionTypes.TURN_BOOKING_SPOTLIGHT_OFF,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Hide Booking Section',
            category: PROFILE_GA_CATEGORY,
        },
    },
});
